module.exports = __webpack_public_path__ + "img/story-2.793be05b.webp";